// Structural deep-equality for plain, JSON-like calculation data: numbers, strings, booleans,
// null/undefined, plain objects, and arrays. This is intentionally NOT a general-purpose deep-equal
// — it does not handle Map/Set/Date/RegExp/class instances, because the only thing it compares is
// the output of the calculation workers, which is always plain data.
//
// It exists so calculation-slice hooks can tell SWR "only re-render me when the slice I selected
// actually changed" — the workers hand back a brand-new result object on every recompute, so
// reference equality is useless here.
export const isDeepEqual = (a, b) => {
  if (a === b) return true;

  // Any primitive mismatch (including one side null/undefined) fails here.
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;

  const aIsArray = Array.isArray(a);
  if (aIsArray !== Array.isArray(b)) return false;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;

  return keysA.every((key) => Object.prototype.hasOwnProperty.call(b, key) && isDeepEqual(a[key], b[key]));
};
